mobileSize = 800;

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 800) {
    $("body").addClass("saffireMobileSize").removeClass("saffireLargeSize");
  }
  if (windowSize > 801) {
    $("body").removeClass("saffireMobileSize");
  }

  // General Message
  $(".generalmessage").prependTo("header");

  // Custom Email Signup
  $(".homepage .emailSignup .emailSignupText").text("LET'S KEEP IN TOUCH");
  $(".homepage .emailSignup .emailInputField input").text(
    "value",
    "ENTER EMAIL"
  );

  $(".homepage .emailSignup .emailSubmitButton").text("SIGN UP");

  // Custom subpage Email Signup
  $(".getUpdatesPageEmailModule .emailSignup .emailSignupText").text(
    "LET'S KEEP ON TOUCH"
  );
  $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").attr(
    "value",
    "ENTER EMAIL"
  );

  $(".getUpdatesPageEmailModule .emailSignup .emailSubmitButton").text(
    "SIGN UP"
  );

  $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").attr(
    "value",
    "ENTER EMAIL"
  );

  // $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").attr(
  //   "value",
  //   "ENTER EMAIL"
  // );
  $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").attr(
    "placeholder",
    "ENTER EMAIL"
  );
  $(".getUpdatesPageEmailModule .emailSignup .emailInputField input").val("");

  // widget ads
  $(
    ".homepage .card-widget-item .card-content .card-widget-title .moreButton"
  ).text("SIGN UP");

  if ($(window).width() < 973) {
    $("header.header #fairgroundsHeaderTickets").appendTo(
      "#fairgroundsFeatureImage .card-widget-item .image-container"
    );
  } else {
    $(
      "#fairgroundsFeatureImage .card-widget-item .image-container #fairgroundsHeaderTickets"
    ).appendTo("header.header .main-container");
  }

  $('.navDummyLink:contains("Festival of Lights")')
    .closest(".group")
    .addClass("fairgrounds-festival-nav");

  // Subpage Logo URL
  $("body.fairground-subpage header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );
  $("body.fairgrounds-theme header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );

  //
});

$(window).load(function () {
  $("body").addClass("pageIsLoaded");
  $(".fairground-subpage .afterContent .fairgrounds-wrapper-outer").prependTo(
    ".fairground-subpage .content"
  );

  if ($(window).width() < 973) {
    $("header.header #fairgroundsHeaderTickets").appendTo(
      "#fairgroundsFeatureImage .card-widget-item .image-container"
    );
  } else {
    $(
      "#fairgroundsFeatureImage .card-widget-item .image-container #fairgroundsHeaderTickets"
    ).appendTo("header.header .main-container");
  }

  $('.navDummyLink:contains("Festival of Lights")')
    .closest(".group")
    .addClass("fairgrounds-festival-nav");

  // Create localStorage to apply subpage theme to checkout process
  const body = $("body");

  // Check if the body has the theme classes
  const hasThemeClasses =
    body.hasClass("fairground-subpage") || body.hasClass("fairgrounds-theme");

  // Check if the body has the class 'checkoutPage'
  let isCheckoutPage = body.hasClass("checkoutPage");

  // Check if the last checkout step is active
  let isLastCheckoutStep = $(".checkout-steps span:last").hasClass(
    "checkout-steps__progress"
  );

  // Check if the session storage item exists
  const siteTheme = sessionStorage.getItem("siteTheme");

  // If the body has the theme classes and the session storage item is not set, set it
  if (hasThemeClasses && !siteTheme && !isLastCheckoutStep) {
    sessionStorage.setItem("siteTheme", "true");
  } 

  if (isCheckoutPage && siteTheme === "true") {
    body.addClass("fairgrounds-theme");
  } 
  
  if (isCheckoutPage && isLastCheckoutStep) {
    sessionStorage.removeItem("siteTheme");
  }

  // Subpage Logo URL
  $("body.fairground-subpage header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );
  $("body.fairgrounds-theme header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );
});

var i;
var divs = document.getElementsByClassName(".featureItemTitle");
for (i = 0; i < divs.length; i++) {
  if (divs[i].className == "myclass") {
    divs[i].innerHTML = divs[i].innerHTML.substring(0, 3);
  }
}

$(window).resize(function () {
  if ($(window).width() < 973) {
    $("header.header #fairgroundsHeaderTickets").appendTo(
      "#fairgroundsFeatureImage .card-widget-item .image-container"
    );
  } else {
    $(
      "#fairgroundsFeatureImage .card-widget-item .image-container #fairgroundsHeaderTickets"
    ).appendTo("header.header .main-container");
  }

  $('.navDummyLink:contains("Festival of Lights")')
    .closest(".group")
    .addClass("fairgrounds-festival-nav");
  // Subpage Logo URL
  $("body.fairground-subpage header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );
  $("body.fairgrounds-theme header.header .header-logo").attr(
    "href",
    "/festival-of-lights"
  );
});

